import { AuctionLotModel, WineDefinitionModel } from ".";

export class AuctionMixedLotModel {
    AuctionLotId: number;
    WineDefinitionId: number;
    WineDefinition: WineDefinitionModel;
    Quantity: number;
    EstimatePrice: number;

    constructor() {
    }
}